import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from 'styles/colors';
import { devices } from 'styles/devices';

const Breadcrumbs = () => {
   const location = useLocation();
   const params = useParams();
   const [breadcrumbs, setBreadcrumbs] = useState([]);

   const cutLink = (l) => {
      switch (true) {
         case l.includes('https://info-cms.konsport.com/katalog/'):
            return l.replace('https://info-cms.konsport.com/katalog/', '');
         case l.includes('https://info-cms.konsport.com/uncategorized/'):
            return l.replace('https://info-cms.konsport.com/uncategorized/', '');
         default:
            return l;
      }
   };

   useEffect(() => {
      if (params?.productId) {
         axios.get(`/wp/v2/posts/${params?.productId}`).then(({ data }) => {
            const link = cutLink(data?.link || '');
            const splitLink = link.split('/');
            const categories = data?.categories;
            const links = [
               {
                  path: `/katalog/produkty`,
                  label: splitLink[0].split('-').join(' '),
                  state: {
                     tag: '',
                     category: [splitLink[0].split('-').join(' '), ...categories]
                  }
               },
               {
                  path: location?.pathname,
                  label: data?.title?.rendered
               }
            ];

            setBreadcrumbs(links);
         });
      }
   }, [location]);

   return breadcrumbs?.length ? (
      <List>
         {breadcrumbs.map((link) => (
            <ListItem key={Math.random()}>
               <StyledLink
                  to={{
                     pathname: link.path,
                     state: link.state || null
                  }}
               >
                  {link.label}
               </StyledLink>
            </ListItem>
         ))}
      </List>
   ) : (
      <></>
   );
};

const List = styled.ul`
   display: flex;
   flex-wrap: wrap;
   padding: 0;
   margin: 8px 0 20px;
   list-style-type: none;

   ${devices.tabletXL} {
      margin: 0;
   }
`;

const ListItem = styled.li`
   display: block;
   padding: 0;
   margin: 0 4px 0 0;
   font-size: 12px;
   text-transform: capitalize;

   &:not(:last-of-type)::after {
      content: '';
      display: inline-block;
      padding: 1.5px;
      border: solid ${colors.primary};
      border-width: 0 1.5px 1.5px 0;
      margin: 0 2px 3px 6px;
      transform: rotate(-45deg);
   }
`;

const StyledLink = styled(Link)`
   color: ${colors.neutral50};

   &:hover {
      color: ${colors.neutral30};
      text-decoration: none;
   }
`;

export default Breadcrumbs;
